import { useCallback } from 'react';
import { Scheme } from 'modules/overlay-canvas/types';

type ISetToLocalStorage = {
  scheme?: Scheme;
  boardId?: number;
  templateId?: number;
  resolution?: { width: number; height: number };
  boardType?: string;
  from?: string;
  boardName?: string;
};

type IGetFromLocalStorage = ISetToLocalStorage & {
  userId?: number;
};

export default function useLocalStorage() {
  const clearData = useCallback(() => {
    localStorage.removeItem('scheme');
    localStorage.removeItem('resolution');
    localStorage.removeItem('boardId');
    localStorage.removeItem('boardType');
  }, []);

  const setData = useCallback((props: ISetToLocalStorage) => {
    const { scheme, boardId, resolution, boardType, from, templateId, boardName } = props;
    scheme && localStorage.setItem('scheme', JSON.stringify(scheme));
    resolution && localStorage.setItem('resolution', JSON.stringify(resolution));
    boardId && localStorage.setItem('boardId', boardId.toString());
    boardType && localStorage.setItem('boardType', boardType);
    from && localStorage.setItem('from', from);
    templateId && localStorage.setItem('templateId', templateId.toString());
    boardName && localStorage.setItem('boardName', boardName);
  }, []);

  const getData = useCallback((): IGetFromLocalStorage => {
    const scheme = localStorage.getItem('scheme');
    const userId = localStorage.getItem('imgame:activeTournamentId');
    const resolution = localStorage.getItem('resolution');
    const boardId = localStorage.getItem('boardId');
    const boardType = localStorage.getItem('boardType');
    const from = localStorage.getItem('from');
    const templateId = localStorage.getItem('templateId');
    const boardName = localStorage.getItem('boardName');

    const transformUserId = userId ? Number(userId) : undefined;
    const transformBoardId = boardId ? Number(boardId) : undefined;
    const transformResolution:
      | {
          width: number;
          height: number;
        }
      | undefined = resolution ? JSON.parse(resolution) : undefined;
    const transformScheme: Scheme | undefined = scheme ? JSON.parse(scheme) : undefined;
    const transformTemplateId = templateId ? Number(templateId) : undefined;

    return {
      userId: transformUserId,
      boardId: transformBoardId,
      resolution: transformResolution,
      scheme: transformScheme,
      boardType: boardType ?? undefined,
      from: from ?? undefined,
      templateId: transformTemplateId,
      boardName: boardName ?? undefined,
    };
  }, []);

  return { setData, getData, clearData };
}
